import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export function Layout() {
  return (
    <div className="min-h-screen relative overflow-hidden selection:bg-primary-500/30 selection:text-white">
      {/* HUD Background Overlay */}
      <div className="fixed inset-0 pointer-events-none bg-[radial-gradient(circle_at_50%_-20%,rgba(14,165,233,0.15),transparent)] z-0" />
      <Header />

      <main className="relative z-10 pt-16 md:pt-20 pb-20 md:pb-0 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}